import React, { useEffect } from 'react';

import { observer } from 'mobx-react';

import { LbPagination } from '@infoods/lifebase-ui';

import { PageTitle, EmptyList } from '../../../../../shared/components/ui-components';
import { participantsListStore } from '../../../../stores/participantsListStore';
import { ParticipantsTable } from './ParticipantsTable/ParticipantsTable';

type ParticipantsTabProps = {
  challengeId: number;
};

const ParticipantsTab = observer(({ challengeId }: ParticipantsTabProps) => {
  const { filterMethods, initParticipantsTab, setDefaultValues } = participantsListStore;
  const { isShowPlaceholder, elementsPerPage, totalElements, getPaginationProps } =
    filterMethods;

  useEffect(() => {
    initParticipantsTab(challengeId);

    return () => setDefaultValues();
  }, []);

  return (
    <div>
      <PageTitle title="Participants" customTopMargin />
      <ParticipantsTable />
      <EmptyList
        show={isShowPlaceholder}
        isSearch={false}
        description="There are no participants"
      />
      <LbPagination
        variant="outBox"
        {...getPaginationProps()}
        elementsPerPage={elementsPerPage}
        totalElements={totalElements}
      />
    </div>
  );
});

export { ParticipantsTab };
